<template>
  <d-page>
    <video v-if="details.articleType === 4" :poster="details.fileUrl" :src="details.fileUrl" controls />
    <div class="container">
      <h2>{{ details.title }}</h2>

      <audio v-if="details.articleType === 5" :src="details.fileUrl" controls></audio>
      <div class="dates">
        <p>{{ details.publishTime }}</p>
        <div class="rate">
          <span>热度</span>
          <rate v-model="details.hotStar" color="#FF960A" :size="15" void-icon="star" void-color="#FFE5C2" />
        </div>
      </div>

      <div class="content" v-html="details.content"></div>
      <div class="mt-24" v-if="details.bannerList && details.bannerList.length">
        <img
          class="banner-img"
          v-for="item in details.bannerList"
          :src="item.imgPath"
          alt=""
          @click="handleClick(item)"
        />
      </div>

      <d-footer v-if="isKmFlag">
        <div class="footer">
          <button class="footer__btn" v-track="{ controlName: '转发' }" @click="share()">
            <img src="../../assets/images/icon/分享.png" />
            转发
          </button>
          <button
            :class="['footer__btn', { checked: details.collectedFlag }]"
            v-track="{ controlName: '收藏' }"
            @click="collectHandle"
          >
            <img src="../../assets/images/icon/收藏.png" v-if="!details.collectedFlag" />
            <img src="../../assets/images/icon/收藏1.png" v-else />
            {{ collectText }}
          </button>
          <button
            :class="['footer__btn', { checked: details.likedFlag }]"
            v-track="{ controlName: '点赞' }"
            @click="checkHandle"
          >
            <img src="../../assets/images/icon/点赞.png" v-if="!details.likedFlag" />
            <img src="../../assets/images/icon/点赞1.png" v-else />
            {{ likeText }}
            <span class="badge" v-if="details.likedFlag && details.likesCount > 0">{{ details.likesCount }}</span>
          </button>
        </div>
      </d-footer>
    </div>
  </d-page>
</template>

<script>
  import { Rate, Badge, Progress } from 'vant'
  import DFooter from '../../components/d-footer/index'
  import {
    apiArticleArticleDetail,
    apiUserActionUserAction,
    apiUserActionUserActionCancel
  } from '@/generated_api/resource'
  import app from '@/jssdk'
  import { getLocalStorage } from '@dcb/utils'

  export default {
    name: 'detail',
    components: { DFooter, Rate, Badge, Progress },
    data() {
      return {
        details: {
          bannerList: []
        },
        checked: false,
        collected: false,
        collectText: '收藏',
        likeText: '点赞',
        isKmFlag: false,
        percent: 0
      }
    },
    created() {
      this.isKmFlag = this.isKm()
      this.getDetails()
    },
    methods: {
      handleClick(item) {
        if (item.linkUrl) {
          app.navigateTo({ url: item.linkUrl })
        }
      },
      async share() {
        console.log('分享')
        // 默认 logo 图
        let shareImgUrl = 'https://kmgz.obs.cn-southwest-2.myhuaweicloud.com/resource/%E7%9F%BF%E7%BE%8E%20logo.png'
        if (this.details.imageUrls) {
          shareImgUrl = this.details.imageUrls.split(',')[0]
        }
        let shareTitle = this.details.title
        let shareUrl = location.href
        console.log('分享图url：', shareImgUrl)
        console.log('分享连接：', shareUrl)
        console.log('分享标题：', shareTitle)
        if (!getLocalStorage('token')) {
          app.navigateTo({
            url: 'km://pages/login/login'
          })
        } else {
          await app.share({
            // provider: 'weixin',
            // scene: 'WXSceneSession',
            // type: 0,
            href: shareUrl,
            title: shareTitle,
            imageUrl: shareImgUrl
          })
          console.log('====分享唤起结束====')
        }
      },
      getDetails() {
        apiArticleArticleDetail({
          id: this.$route.query.id
        }).then(data => {
          this.details = data
        })
      },
      //点赞
      checkHandle() {
        if (!this.details.likedFlag) {
          apiUserActionUserAction({
            userActionType: '1',
            objectType: '0',
            objectId: this.details.id
          }).then(data => {
            this.details.likedFlag = true
            this.likeText = '已赞'
            this.getDetails()
            this.$toast('点赞成功')
          })
        } else {
          apiUserActionUserActionCancel({
            userActionType: '1',
            objectType: '0',
            objectId: this.details.id
          }).then(data => {
            this.details.likedFlag = false
            this.likeText = '点赞'
            this.getDetails()
            this.$toast('已取消')
          })
        }
      },
      //收藏
      collectHandle() {
        if (!this.details.collectedFlag) {
          apiUserActionUserAction({
            userActionType: '0',
            objectType: '0',
            objectId: this.details.id
          }).then(data => {
            this.details.collectedFlag = true
            this.collectText = '已收藏'
            this.getDetails()
            this.$toast('已收藏')
          })
        } else {
          apiUserActionUserActionCancel({
            userActionType: '0',
            objectType: '0',
            objectId: this.details.id
          }).then(data => {
            this.details.collectedFlag = false
            this.collectText = '收藏'
            this.getDetails()
            this.$toast('已取消收藏')
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  video {
    width: 100%;
  }

  .container {
    background: #ffffff;
    min-height: 100vh;
    padding: 16px;
    overflow-x: hidden;

    h2 {
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
    }

    .dates {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;

      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }

      .rate {
        width: 156px;
        height: 28px;
        background: #fff9f1;
        border-radius: 14px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff960a;
          line-height: 28px;
          margin-right: 12px;
        }
      }
    }

    .content {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 26px;
      margin-top: 16px;
      word-break: break-all;

      > p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        margin-top: 16px;
      }

      /deep/ table,
      /deep/ tr,
      /deep/ tbody,
      /deep/ img {
        max-width: calc(100vw - 24px) !important;
      }
    }

    .footer {
      height: 48px;
      background: #ffffff;
      box-shadow: 0px -1px 2px 0px rgba(239, 239, 239, 0.5);
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: auto;

      button {
        background: none;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        display: flex;
        align-items: center;
        position: relative;

        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }

        .badge {
          position: absolute;
          top: 0;
          right: -25px;
          font-size: 8px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #165ebf;
          line-height: 11px;
        }

        &:last-child {
          margin-right: 12px;
        }

        &.checked {
          color: #165ebf;
        }
      }
    }
  }

  .banner-img {
    margin-bottom: 12px;
    width: 100%;
    /*height: 100px;*/
    border-radius: 8px;
  }

  audio {
    margin-top: 12px;
    width: 100%;
  }

  video::-webkit-media-controls-start-playback-button {
    display: none;
  }
</style>
